import axios from "axios";
import * as types from "../mutation-types";
import { getProjectByProId } from "./projects";
import { getEventIndexById } from "./fullcalendar";
import logger from "~/utilities/logger";

// state
export const state = {
  country_list: [],
  index_data: null,
  country_select: null,
  the_id: null,
};

// getters
export const getters = {
  country_list: (state) => state.country_list,
  index_data: (state) => state.index_data,
  check_list: (state) => state.country_list !== null,
  country_select: (state) => state.country_select,
  the_id: (state) => state.the_id,
};

//utils
export const getCountryIndexById = (state, couId) =>
  state.country_list.findIndex(
    (country) => country.cou_id.toString() === couId.toString()
  );
export const getCountryByCouId = (state, couId) =>
  state.country_list.find(
    (country) => country.cou_id.toString() === couId.toString()
  );
export const getCountryByCouIso = (state, couIso) =>
  state.country_list.find(
    (country) => country.cou_iso.toString() === couIso.toString()
  );

// mutations
export const mutations = {
  [types.ADD_COUNTRY](state, country)
  {
    return state.country_list.push(country);
  },
  [types.ADD_COUNTRY_FAILURE](state, error) {},

  [types.FETCH_COUNTRIES](state, { country_list, index_data })
  {
    state.index_data = index_data;
    return (state.country_list = country_list);
  },

  [types.FETCH_COUNTRIES_FAILURE](state)
  {
    logger.error("FETCH_COUNTRIES_FAILURE");
  },

  [types.FETCH_COUNTRY](state, { country_select })
  {
    return (state.country_select = country_select);
  },

  [types.FETCH_COUNTRY_FAILURE](state, { error })
  {
    logger.error("FETCH_COUNTRY_FAILURE", error);
  },

  [types.SELECT_COUNTRY](state, { cou_id })
  {
    let theSelect = getCountryByCouId(state, cou_id);
    logger.log("store.SELECT_COUNTRY", theSelect);
    return (state.country_select = theSelect);
  },

  [types.DESELECT_COUNTRY](state)
  {
    return (state.country_select = null);
  },

  [types.DELETE_COUNTRY](state, { cou_iso })
  {
    logger.log("store.DELETE_COUNTRY", state, cou_iso);
    const index = getCountryByCouIso(state, cou_iso);
    if (index === -1)
    {
      return console.warn(`Unable to delete country (id ${cou_iso})`);
    }
    return state.country_list.splice(index, 1);
  },

  [types.UPDATE_COUNTRY](state, { payload })
  {
    // state.country_select = payload.cou_name;
  },

  [types.SET_COUNTRY_ID](state, { id })
  {
    return (state.the_id = id);
  },

  [types.SEARCH_COUNTRIES](state, { country_list })
  {
    return (state.country_list = country_list);
  },

  [types.SEARCH_COUNTRIES_FAILURE](state, error)
  {
    logger.error("SEARCH_COUNTRIES_FAILURE", error);
  },
};

// actions
export const actions = {
  async addCountry({ commit }, country)
  {
    try
    {
      logger.log("store.addCountry", "/api/countries", country);
      const { data } = await axios.post("/api/countries", country);
      if (data.status && data.status === "success")
      {
        logger.log("store.addCountry rsp", data);
        return commit(types.ADD_COUNTRY, data.data);
      } else
      {
        return commit(types.DELETE_COUNTRY_FAILURE, data);
      }
    } catch (e)
    {
      logger.log("DELETE_COUNTRY_FAILURE", e);
      return commit(types.DELETE_COUNTRY_FAILURE, e);
    }
  },

  async getCountries({ commit }, options)
  {
    try
    {
      let paginate = options && options.paginate ? options.paginate : 10000;
      let extraOptions =
        options && options.extra_options ? options.extra_options : "";
      let format = options && options.format ? options.format : "minimal";

      const { data } = await axios.get(
        `/api/countries?status=active&paginate=${paginate}&format=${format}${extraOptions}`
      ); //todo
      logger.log("store.getCountries", data);
      return commit(types.FETCH_COUNTRIES, { country_list: data.data });
    } catch (e)
    {
      logger.error("store.getCountries error", e);
      return commit(types.FETCH_COUNTRIES_FAILURE);
    }
  },

  async getCountry({ commit, dispatch }, payload)
  {
    if (!payload.cou_id) return;
    let extraOptions =
      payload && payload.extra_options ? payload.extra_options : "";
    let format = payload && payload.format ? payload.format : "minimal";
    try
    {
      const { data } = await axios.get(`/api/countries/${payload.cou_id}`);
      logger.log("store.getCountry rsp", data);
      return commit(types.FETCH_COUNTRY, { country_select: data.data });
    } catch (e)
    {
      logger.log(e);
      return commit(types.FETCH_COUNTRY_FAILURE, { error: e });
    }
  },

  async deleteCountry({ commit, dispatch }, payload)
  {
    if (!payload.cou_iso) return;
    let paginate = payload && payload.paginate ? payload.paginate : 10000;
    let extraOptions =
      payload && payload.extra_options ? payload.extra_options : "";
    try
    {
      const { data } = await axios.delete(
        `/api/countries/${payload.cou_iso}${extraOptions}`
      );
      logger.log("store.deleteCountry rsp", data);
      return commit(types.DELETE_COUNTRY, { cou_iso: payload.cou_iso });
    } catch (e)
    {
      logger.error("DELETE_COUNTRY_FAILURE", e);
      // return commit(types.DELETE_COUNTRY_FAILURE, { error: e });
    }
  },

  async updateCountry({ commit, dispatch }, payload)
  {
    try
    {
      const { data } = await axios.put(
        `/api/countries/${payload.cou_iso}`,
        payload
      );
      logger.log("store.updateCountry", data);
      return commit(types.UPDATE_COUNTRY, { payload: data.data });
    } catch (e)
    {
      logger.log(e);
      return commit(types.FETCH_COUNTRY_FAILURE, { error: e });
    }
  },

  setCountryID({ commit, dispatch }, id)
  {
    return commit(types.SET_COUNTRY_ID, { id: id });
  },

  async searchCountries({ commit }, query)
  {
    try
    {
      const { data } = await axios.get(`/api/countries?search=${query}`);
      logger.log("store.searchCountries", data);
      return commit(types.SEARCH_COUNTRIES, { country_list: data.data.data });
    } catch (e)
    {
      logger.error("store.searchCountries error", e);
      return commit(types.SEARCH_COUNTRIES_FAILURE, e);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
